import { render } from "./ServicesAndSectorsSection.vue?vue&type=template&id=cc385cdc"
import script from "./ServicesAndSectorsSection.vue?vue&type=script&lang=js"
export * from "./ServicesAndSectorsSection.vue?vue&type=script&lang=js"

import "./ServicesAndSectorsSection.vue?vue&type=style&index=0&id=cc385cdc&lang=css"

import exportComponent from "Z:\\Backups\\Backup Site tecmar\\07.10.2026\\tecmar-transportes-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__